export default __webpack_public_path__ + "static/media/pig.c37b3689.png";